export default __webpack_public_path__ + "static/media/info.eb998447.png";